import React from 'react'
import Slider from 'react-slick';
import App1 from '../images/new_watcho.jpeg'
import App2 from '../images/new_Jiohotstar.jpeg'
import App3 from '../images/new_Sonyliv.jpeg'
import App4 from '../images/new_Zee5.jpeg'
import App5 from '../images/new_Chaupal.jpeg'
import App6 from '../images/new_fancode.jpeg'
import App7 from '../images/new_stage.jpeg'
import App8 from '../images/new_Shimaroo.jpeg'
import App9 from '../images/new_shortstv.jpeg'
import App10 from '../images/new_aoohit.jpeg'
import App11 from '../images/new_tarang.jpeg'
import App12 from '../images/new_Raj.jpeg'
import App13 from '../images/new_sanskar.jpeg'
import App14 from '../images/new_games.jpeg'
import App15 from '../images/new_QZ.jpeg'
import App16 from '../images/new_discovery.jpeg'

export const Ottslider = () => {
    var settings2 = {
        dots: false,
        navigation: true,
        loop: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: false,
        speed: 300,
        autoplaySpeed: 3000,
        cssEase: "linear"
      };
  return (
    <>
      <div className='ottslider'>
                                <Slider {...settings2}>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App1} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                <div className='ottimg'>
                                  <img src={App2} alt='Sony Live'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App3} alt='Disney Hotstar'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App4} alt='History'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App5} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App6} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App7} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App8} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App9} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App10} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App11} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App12} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App13} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                  <div className='ottimg'>
                                  <img src={App14} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                    <div className='ottimg'>
                                  <img src={App15} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                  <div>
                                      <div className='ottimg'>
                                  <img src={App16} alt='Amazon Prime'/>                              
                                </div>
                                  </div>
                                </Slider>
                                </div>
    </>
  )
}
